import Masonry from 'masonry-layout';

const ENABLE = window.matchMedia("only screen and (min-width: 768px)").matches

if(ENABLE){
  new Masonry( '.js-references', {
    horizontalOrder: true,
    itemSelector: '.references__item',
    gutter: 20
  })
}
